import polypaneRyan from "../../../../assets/images/blogs/ryan/polypane-ryan.jpg";
import * as React from 'react';
export default {
  polypaneRyan,
  React
};